import { TableCell } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  '&.MuiTableCell-head': {
    fontSize: '13px',
    padding: '16px 16px',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    width: 'auto',
    whiteSpace: 'nowrap',
    borderBottom: `2px solid ${theme.palette.grey[400]}`,
    '&:first-of-type': {
      top: 0,
      left: 0,
      zIndex: 3,
      position: 'sticky',
    },
  },
  '&.MuiTableCell-body': {
    fontSize: '12px',
    '&:first-of-type': {
      left: '0px',
      position: 'sticky',
      zIndex: 1,
      background: 'inherit',
      '& span': {
        lineHeight: '24px',
      },
    },
  },
}))

export default StyledTableCell
